
export type CreateChatThread200AllOfCurrentUserStatusStatus = typeof CreateChatThread200AllOfCurrentUserStatusStatus[keyof typeof CreateChatThread200AllOfCurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatThread200AllOfCurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
